module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/congress/congress.component.css
// module id = ./src/congress/congress.component.css
// module chunks = main